export var deepCopy = function (objToCopy) {
    var type = Object.prototype.toString;
    var result = type.call(objToCopy) === '[object Array]'
        ? []
        : type.call(objToCopy) === '[object Object]'
            ? {}
            : undefined;
    if (result !== undefined) {
        for (var key in objToCopy) {
            if (Object.prototype.hasOwnProperty.call(objToCopy, key)) {
                result[key] = deepCopy(objToCopy[key]);
            }
        }
        return result;
    }
    return objToCopy;
};
